// Tilts its [data-tilt-surface] toward the pointer in 3D; only runs when the visitor allows motion.
class STiltCard extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
    this.surface = this.querySelector('[data-tilt-surface]');
    if (!this.surface) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.addEventListener('pointermove', (event) => this.#track(event), opts);
    this.addEventListener('pointerleave', () => this.#reset(), opts);
    this.addEventListener('pointercancel', () => this.#reset(), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #track(event) {
    const rect = this.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      this.dataset.tilting = '';
      this.style.setProperty("--tilt-x", `${(-y * 28).toFixed(2)}deg`);
      this.style.setProperty("--tilt-y", `${(x * 36).toFixed(2)}deg`);
      this.style.setProperty('--glare-x', `${((x + 0.5) * 100).toFixed(1)}%`);
      this.style.setProperty('--glare-y', `${((y + 0.5) * 100).toFixed(1)}%`);
    });
  }

  #reset() {
    cancelAnimationFrame(this.#frame);
    delete this.dataset.tilting;
    this.style.removeProperty('--tilt-x');
    this.style.removeProperty('--tilt-y');
  }
}

if (!customElements.get('s-tilt-card')) {
  customElements.define('s-tilt-card', STiltCard);
}
